import {
  AgendamentoPayload,
  GetComprovante,
  GetDatasDisponiveis,
  GetLimiteAgendamentos,
  GetPedidoItems,
} from "../../types/agendarTypes";
import { AuthCheck, Login, LoginServerResponse } from "./../../types/authTypes";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const api = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    baseUrl: `http://${process.env.REACT_APP_API_HOST}:${process.env.REACT_APP_API_PORT}/`,
    prepareHeaders: (headers, { getState, endpoint }) => {
      const token = localStorage.getItem("token");

      if (token && endpoint !== "refresh") {
        headers.set("x-access-token", token);
      }
    },
  }),
  endpoints: (builder) => ({
    authCheck: builder.mutation<AuthCheck, string>({
      query: (token) => ({ url: "authcheck", method: "POST", body: { token } }),
    }),
    authenticate: builder.mutation<LoginServerResponse, Login>({
      query: (credentials) => ({
        url: "login",
        method: "POST",
        body: credentials,
      }),
    }),
    getPedidoItemsByNumped: builder.mutation<
      GetPedidoItems[],
      { numped: number }
    >({
      query: ({ numped }) => ({
        url: "/get/pedido-items/" + numped,
        method: "GET",
      }),
    }),
    getDatasDisponiveis: builder.query<GetDatasDisponiveis[], void>({
      query: () => ({
        url: "/get/datas-disponiveis/",
        method: "GET",
      }),
    }),
    getComprovanteByNumped: builder.mutation<
      GetComprovante[],
      { numped: number }
    >({
      query: ({ numped }) => ({
        url: "/get/comprovante/" + numped,
        method: "GET",
      }),
    }),
    postAgendamento: builder.mutation<void, { payload: AgendamentoPayload[] }>({
      query: (payload) => ({
        url: "/post/agendamento/",
        method: "POST",
        body: payload,
      }),
    }),
    getLimiteAgendamentos: builder.query<GetLimiteAgendamentos[], void>({
      query: (payload) => ({
        url: "/get/limite/agendamentos",
        method: "GET",
      }),
    }),
    getLimiteAgendamentoByData: builder.mutation<
      { PESO_TOTAL: number; PAL_TOTAL: number }[],
      { dtagenda: string }
    >({
      query: ({dtagenda}) => ({
        url: "/get/limite/agendamento/"+dtagenda,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useAuthCheckMutation,
  useAuthenticateMutation,
  useGetPedidoItemsByNumpedMutation,
  useGetDatasDisponiveisQuery,
  useGetComprovanteByNumpedMutation,
  usePostAgendamentoMutation,
  useGetLimiteAgendamentosQuery,
  useGetLimiteAgendamentoByDataMutation
} = api;
